module.exports = __webpack_public_path__ + "media/images/fr/upload-print-b0670f70a84c5b54e4ecf17c65d0f157.png";